import React, { Component, Fragment } from "react";
import Chart from "react-apexcharts";
import aggregacao from "../aggregacao";
import chartConfig from "../chartConfig";
import { parseLabelCampo } from "../../../../constants/metricas";

const MESES = ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"];

export default class ComparativoUnidadeMes extends Component {

    constructor(props) {
        super(props);
        this.chartRef = React.createRef();
    }

    montaSeries = () => {
        let { linhas, campo } = this.props;
        let pivot = aggregacao.somaPorGrupoEMes(linhas || [], "unidade", campo);
        return Object.keys(pivot).map((unidade) => ({
            name: unidade,
            data: MESES.map((mes) => pivot[unidade][mes] || 0),
        }));
    }

    // Esse gráfico mostra a série anual inteira e não filtra dados por `mes`
    // (diferente dos outros widgets do Dashboard Consolidado) -- quando um mês
    // específico está selecionado no filtro, só destaca visualmente a coluna
    // correspondente. Ver chartConfig.js.
    montaOptions = (series) => {
        let { campo, mes } = this.props;
        let indiceMes = mes ? MESES.indexOf(mes) : -1;
        return {
            ...chartConfig.optionsBase({ titulo: parseLabelCampo(campo), tipo: "bar" }),
            colors: chartConfig.paletaComDestaque(chartConfig.PALETA, series.length, indiceMes),
            dataLabels: { formatter: chartConfig.formatterComDestaque(indiceMes) },
            xaxis: { categories: MESES, title: { text: "Mês" } },
        };
    }

    // Regressão: o wrapper `react-apexcharts` só chama `chart.updateOptions()`
    // quando `JSON.stringify(prevProps.options) !== JSON.stringify(props.options)`
    // -- mas `colors`/`dataLabels.formatter` aqui são funções (pra colorir/
    // rotular por dataPointIndex), e `JSON.stringify` ignora funções (viram
    // `null` dentro de um array, ou somem de um objeto). Resultado: da 2ª troca
    // de mês em diante, o JSON antes/depois é idêntico pro wrapper, que então
    // nunca propaga o novo destaque pro gráfico já montado -- só a 1ª seleção
    // funcionava. Chamando `updateOptions` direto na instância real do
    // ApexCharts (exposta como `this.chart` pelo wrapper via `ref`) contorna
    // esse diff quebrado.
    componentDidUpdate(prevProps) {
        if (prevProps.mes !== this.props.mes || prevProps.campo !== this.props.campo) {
            let chart = this.chartRef.current && this.chartRef.current.chart;
            if (chart) chart.updateOptions(this.montaOptions(this.montaSeries()));
        }
    }

    render() {
        let series = this.montaSeries();
        let options = this.montaOptions(series);

        return (
            <Fragment>
                <div className="row">
                    <div className="col-md-12">
                        <Chart ref={this.chartRef} options={options} series={series} type="bar" height={350} />
                    </div>
                </div>
            </Fragment>
        )
    }
}
